import { TransmissionType } from 'graphql/generated';

export const TransmissionTypeValues: { [key in TransmissionType]: string } = {
  automatic: 'Automatic',
  manual: 'Manual',
  cvt: 'CVT',
  na: 'N/A',
  other: 'Other',
  unknown: 'Unknown',
};

export const fromTransmissionTypeValue = (value: string) => {
  switch (value) {
    case 'Automatic':
      return TransmissionType.automatic;
    case 'Manual':
      return TransmissionType.manual;
    case 'CVT':
      return TransmissionType.cvt;
    case 'N/A':
      return TransmissionType.na;
    case 'Other':
      return TransmissionType.other;
    case 'Unknown':
      return TransmissionType.unknown;
    default:
      throw new Error(`invalid TransmissionType value: ${value}`);
  }
};
